(function($) {

  Drupal.behaviors.mpp = {
    attach: function(context, settings) {
      var productsArray = page_data['catalog-mpp'].products;
      $(".js-product-brief").each(function() {
        var productId = $(this).attr('data-product-id'),
            skuId     = $(this).attr('data-sku-id');

        var productData = {};
        if (_.isEmpty(skuId)) {
          productData = _.find(productsArray, function(p) {
            return p.PRODUCT_ID == productId;
          });
        }
        else {
          productData = _.filter(productsArray, function(p) {
            return p.PRODUCT_ID == productId;
          });

          var skus = [];
          product_data_loop:
          for (var i = 0, j = productData.length; i < j; i++) {
            if (!!productData[i].skus) {
              for (var k = 0, l = productData[i].skus.length; k < l; k++) {
                if (productData[i].skus[k].SKU_BASE_ID == skuId) {
                  break product_data_loop;
                }
              }
            }
          }

          productData = productData[i];  // Technically this will default to the last value if all else fails
        }

        site.product.view.extendedMPP({
          containerNode: this,
          productData: productData
        });

        //ie8 pie attach behavior
        if (generic.env.isIE8) {
          if (window.PIE) {
            $('.swatches--single div').each(function(i, el) {
              PIE.attach(this);
            });
          }
        }
      });

      site.product.view.miscFlagAlign($('.mpp__product'));
      site.product.view.equalRowHeight($('.mpp__product'));
      //Update Row Bottom Content
      site.product.view.equalMPPRowBottomHeightFunc($('.mpp__product'));
      $('.mpp__product-grid .mpp__product:nth-child(3n+2)').addClass('nth-child-3np2');
      $(".product_brief__image").off('mouseover').off('mouseout');

      $(".product_brief__image").on('mouseover', function() {
        var newBgImg = $(this).attr('data-sku-alt-image');
        if($(this).next()[0].naturalWidth != 0) {
         $(this).attr("src", newBgImg);
        }
        $(this).parent().nextAll(".rollover_plus").find("img").attr("src","/media/export/cms/mpp/minus_black.png");
      }).mouseout(function() {
        var newBgImg = $(this).attr('data-sku-image');
        $(this).attr("src", newBgImg);
        $(this).parent().nextAll(".rollover_plus").find("img").attr("src","/media/export/cms/mpp/plus.png");
      });

      $(".rollover_plus").on("mouseover",function() {
        var imgContainer = $(this).prev().find('.product_brief__image');
        var newBgImg = imgContainer.attr('data-sku-alt-image');
        if(imgContainer.next()[0].naturalWidth != 0) {
         imgContainer.attr("src", newBgImg);
        }
        $(this).find("img").attr("src","/media/export/cms/mpp/minus_black.png");
      }).live("mouseout",function() {
        var imgContainer = $(this).prev().find('.product_brief__image');
        var newBgImg = imgContainer.attr('data-sku-image');
        imgContainer.attr("src", newBgImg);
        $(this).find("img").attr("src","/media/export/cms/mpp/plus.png");
      });
      //Product Sort
      site.productSort.init(productsArray);


    }
  };

})(jQuery);
